import * as React from 'react';
import UploadAndShow from './Components/UploadAndShow';
import "./Components/Estimator.css";
import { useEffect, useState } from 'react';
import UserManual from './Components/UserManual.jsx';
import LoginPage from './EntraID/LoginPage';
import { MsalProvider, AuthenticatedTemplate, useMsal, UnauthenticatedTemplate, useIsAuthenticated } from "@azure/msal-react";
import { BrowserUtils, InteractionRequiredAuthError, SilentRequest } from "@azure/msal-browser";

const App: React.FC = () => {
    const [files, setFiles] = useState<File[]>([]);

    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [userDisplayName, setUserDisplayName] = useState('');

    const { instance } = useMsal();
    const isAuthenticated = useIsAuthenticated();
    const account = instance.getActiveAccount();

    const APPLICATION_ID = process.env.REACT_APP_APPLICATION_ID;
    const [accessToken, setAccessToken] = useState<string | null>(null);

    useEffect(() => {
        console.log("Component mounted. Checking login status...");
        if (isAuthenticated && account) {
            setIsLoggedIn(true);
            setUserDisplayName(account.name || "UNKNOWN USER");
        }
    }, []);

    const handleLogin = async () => {
        console.log("Logging in with Entra ID...");

        var response; // TODO: Make sure this is secure and viable as setting it
                      // to a value gives an error.
        console.log("Trying silent login...");

        try {
            // Try silent login first.
            try {
                response = await instance.ssoSilent({
                    scopes: ["User.read"], // Replace with required scopes.
                });
            } catch (error) {
                console.log("Trying popup login...");
                response = await instance.loginPopup({
                    scopes: ["User.read"],
                });
            }

            if (response.account) {
                console.log(response.account);
                instance.setActiveAccount(response.account);
                setIsLoggedIn(true);
                setUserDisplayName(response.account.name || "UNKNOWN USER");
                // TODO: Redirect
                try {
                    const apiTokenResponse = await instance.acquireTokenSilent({
                        scopes: [`api://${APPLICATION_ID}/user_impersonation`],
                    });
                    console.log("Access Token Response: ", apiTokenResponse);
                    setAccessToken(apiTokenResponse.accessToken);
                } catch (apiError: any) {
                    if (apiError instanceof InteractionRequiredAuthError) {
                        console.warn("Interaction is required � trying popup fallback...");

                        try {
                            const popupResponse = await instance.acquireTokenPopup({
                                scopes: [`api://${APPLICATION_ID}/user_impersonation`],
                            });
                            console.log("Token from popup:", popupResponse.accessToken);
                            setAccessToken(popupResponse.accessToken);
                        } catch (popupError) {
                            console.error("Token popup failed:", popupError);
                        }
                    }
                }
            }
            else {
                console.error("Login failed (no account found)");
                setIsLoggedIn(false);
                alert("Login failed. No account associated with this user.");
            }
        } catch (error: any) {
            console.error("Login failed: ", error);
            setIsLoggedIn(false);
            alert(`Login failed. Please try again. ${error.message}`);
        }
    }

    const handleLogout = async () => {
        if (instance.getActiveAccount()) {
            const activeAccount = instance.getActiveAccount();

            await instance.logoutRedirect({
                account: activeAccount,
                onRedirectNavigate: () => !BrowserUtils.isInIframe(),
            })
                .catch((e) => {
                    console.error("An error occured during logout:", e);
                })
        }
    }

    return (
        <div>
            {!isLoggedIn && (
                <div>
                    <LoginPage
                        handleLogin={handleLogin}
                    />
                </div>
            )}
            {isLoggedIn && (
                <div>
                    <div className="logout-container">
                        <button className="logout-button" onClick={handleLogout}>Logout</button>
                    </div>
                    <UploadAndShow onFilesSelected={setFiles} accessToken={accessToken} />
                    <UserManual />
                </div>
            )}
        </div>
    );
}

export default App;
